import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.treasureHuntGroups.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getGroupsData = createSelector(
  (state) => state.treasureHuntGroups.data.treasureHuntGroups,
  (groups = []) => groups
);
const getCurrencyData = createSelector(
  (state) => state.treasureHuntGroups.data.currency,
  (currency = {}) => currency
);

export default {
  getCurrencyData,
  getGroupsData,
  getHasLoaded,
};
